export function parseJsonToFormData(jsonData: Record<string, string | undefined | null | Blob | boolean>) {
  const formData = new FormData()

  for (const [key, value] of Object.entries(jsonData)) {
    formData.append(key, typeof value === 'boolean' ? value.toString() : value || '')
  }

  return formData
}
